import { render } from "./V12.vue?vue&type=template&id=de865c4a"
import script from "./V12.vue?vue&type=script&lang=js"
export * from "./V12.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stefan.keyser\\source\\wearetriple\\repos\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__